// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"fa9940a2","328":"6107f591"}[chunkId] + ".css";
};